import { SvgChevronright } from '@common/icon';

import { CustomLink } from '@/app/_components/CustomLink';

export function SectionHeader({
  title,
  totalCount,
  moreHref,
}: {
  title: string;
  totalCount?: number;
  moreHref: string;
}) {
  return (
    <div className="flex items-center justify-between py-6 mobile-tablet:px-20">
      <div className="flex items-center gap-8">
        <h2 className="font-700 text-Gray-900 typo-body2 mobile-tablet:text-Gray-black">
          {title}
        </h2>
        {typeof totalCount === 'number' ? (
          <>
            <span aria-hidden className="size-4 rounded-pill bg-Gray-300" />
            <span className="font-700 tracking-[-0.28px] text-Gray-black typo-body4 mobile-tablet:font-500">
              총 {totalCount.toLocaleString()}건
            </span>
          </>
        ) : null}
      </div>
      <CustomLink
        href={moreHref}
        className="flex h-40 items-center gap-4 rounded-xxsmall py-8 font-700 text-Gray-600 typo-body4 mobile-tablet:h-32 mobile-tablet:typo-caption1"
      >
        더보기
        <SvgChevronright className="size-14 mobile-tablet:size-12" />
      </CustomLink>
    </div>
  );
}

